module.exports = __webpack_public_path__ + "static/buyhouse-a842b156caf5d164230f8a691cf8d146.jpg";